<template>
  <div class="translogsocket">
    <div class="translogsocket">
      <title-info>
        <li>报文日志</li>
      </title-info>
      <el-row>
        <el-col :span="6">
          <span>交易码:&nbsp;</span>
          <el-input v-model="originData.transHead"></el-input>
        </el-col>
        <el-col :span="6">
          <span>网点:&nbsp;</span>
          <el-input v-model="originData.orgnCode"></el-input>
        </el-col>
        <el-col :span="12">
          <div>
            <span>接受报文时间:&nbsp;</span>
            <el-date-picker
              v-model="originData.timeStart"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
            &nbsp;&nbsp;至&nbsp;&nbsp;
            <el-date-picker
              v-model="originData.timeEnd"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <span>报文类型:&nbsp;</span>
          <el-input v-model="originData.socketType"></el-input>
        </el-col>
        <el-col
          :span="6"
          :pull="0"
        >
          <span>日志状态:&nbsp;</span>
          <el-select
            v-model="originData.transStatus"
            placeholder="请选择状态"
          >
            <el-option
              label="成功"
              value="0"
            ></el-option>
            <el-option
              label="失败"
              value="1"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <br />
      <div class="search_bottom">
        <button
          class="btn btn--search"
          @click="handleQueryClick"
        >查询</button>
        <button
          class="btn btn--reset"
          @click="handleResetClick"
        >重置</button>
      </div>

      <title-info>
        <li>查询结果列表</li>
      </title-info>
      <div class="loginlog_table">
        <el-table
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column
            label="序号"
            width="50"
          >
            <template slot-scope="scope">
              {{scope.$index+1}}
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip='true'
            prop="transHead"
            label="交易码"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip='true'
            prop="orgnCode"
            label="网点"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip='true'
            label="接受报文时间"
          >
            <template slot-scope="scope">
              {{scope.row.transRespTime | formatDate}}
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip='true'
            prop="socketType"
            label="报文类型"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip='true'
            prop="serviceNo"
            label="服务号"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip='true'
            prop="deviceId"
            label="设备编号"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip='true'
            prop="transStatus"
            label="日志状态"
          >
          </el-table-column>
          <el-table-column
            width="200"
            :show-overflow-tooltip='true'
            prop=""
            label="操作"
          >
            <template slot-scope="scope">
              <button
                type="button"
                class="detailBtn"
                @click="handleDetailClick(scope.row)"
              > 详情</button>
            </template>

          </el-table-column>
        </el-table>
      </div>
      <div class='pagination'>
        <span>共{{sumCount}}条信息，当前
          {{currentPage}}/
          {{(Math.ceil(sumCount/pageSize)==0?1:Math.ceil(sumCount/pageSize))}}页</span>
      </div>
      <el-pagination
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="prev, pager, next,jumper"
        :total="sumCount"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import TitleInfo from '@/components/title.vue';
import { getPagingData } from '@/mixins';

export default {
  name: 'TransLogSocket',
  components: { TitleInfo },
  mixins: [getPagingData],
  data() {
    return {
      // 初始数据
      originData: {
        transHead: '',
        orgnCode: '',
        timeStart: '',
        timeEnd: '',
        socketType: '',
        transStatus: '',
      },
      // 查询数据
      searchParam: {
        transHead: '',
        orgnCode: '',
        timeStart: '',
        timeEnd: '',
        socketType: '',
        transStatus: '',
      },
      serviceNo: '',
      deviceId: '',
      tableData: [],
      sumCount: 0,
      currentPage: 1,
      pageSize: 10,
    };
  },
  watch: {
    currentPage: {
      immediate: true,
      handler() {
        this.getTableData();
      },
    },
  },
  methods: {
    // 查询按钮
    handleQueryClick() {
      this.searchParam = { ...this.originData };
      if (this.currentPage === 1) {
        this.getTableData();
      } else {
        this.currentPage = 1;
      }
    },
    // 重置按钮
    handleResetClick() {
      Object.keys(this.originData).forEach((key) => {
        this.originData[key] = '';
        this.searchParam[key] = '';
      });
    },
    // 获取表格数据
    getTableData() {
      const transStatusMap = {
        0: '成功',
      };
      function transformList(list) {
        return list.map(item => ({
          ...item,
          transStatus: transStatusMap[item.transStatus] || '失败',
        }));
      }
      this.getPagingData(this.$API.messageLogQuery, transformList);
    },
    // 跳转交易日志详情
    handleDetailClick(row) {
      this.addNav({
        name: '报文日志详情',
        path: '/translogsocketDetail',
      });
      sessionStorage.setItem('translogsocketDetail', JSON.stringify(row));
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/css/button.scss";

.detailBtn {
  margin: 0;
  padding: 5px 16px;
  outline: none;
  border: 0;
  height: 26px;
  background-color: #54a6de;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
}
.search_bottom {
  margin-top: 2%;
}
.el-form-item {
  height: 20px;
  margin-left: 10%;
}
</style>
